import React from 'react'
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'

import { Anchors, LinkCustom } from './mixins'

import { DataLayers as PageDataLayers } from '../../constants/gtm-events-ficha-aviso-page'
import features from '../../constants/features-per-country'
import { SITE_ID } from '../../constants'

const showCalculadoraSalario = features[SITE_ID || 'BMAR'].fichaAviso?.calculadoraSalario?.enabled

const Component = ({ children, visibleId }) => {
  const { isMobile, isTabletPortrait, isTabletLandscape } = useWindowSize()

  const scroll = item => {
    const windowPosition = window.pageYOffset
    const targetId = item?.props?.href.substring(1)
    const element = document.getElementById(targetId) as HTMLElement
    const header = document.getElementById('header-component')?.offsetHeight || 118
    const calculadoraContainer = document.getElementById('calculadora-container')?.offsetHeight
    const mobileTopActionBarHeight = document.getElementById('mobile-top-action-bar')?.offsetHeight || 0

    if (element) {
      const elementPosition = element.getBoundingClientRect().top
      let offsetPosition = 0
      if (isMobile || isTabletPortrait) {
        offsetPosition =
          elementPosition +
          windowPosition -
          mobileTopActionBarHeight -
          16 - // 16 del margin header
          header +
          (!showCalculadoraSalario || calculadoraContainer || targetId === 'section-detalle' ? 0 : 216) // 216 = 168 alto calculadora + 48 alto boton postular
      } else if (isTabletLandscape) {
        offsetPosition = elementPosition + windowPosition - 228
      } else {
        offsetPosition = elementPosition + windowPosition - 255
      }

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      })
    }
  }

  return (
    <Anchors>
      {children.map(item => {
        return (
          item && (
            <LinkCustom
              href={item.props.disabled ? '#' : item.props.href}
              onClick={e => {
                e.preventDefault()
                scroll(item)
                if (!item.props.disabled && item.props.eventLabel) {
                  PageDataLayers.switchEntreSolapas(item.props.eventLabel)
                }
              }}
              withIcon={item.props.withIcon}
              isActive={visibleId === item.props.href.substring(1)}
              disabled={item.props.disabled}
              isMobileOrTablet={isMobile || isTabletPortrait || isTabletLandscape}
            >
              {item.props.children}
            </LinkCustom>
          )
        )
      })}
    </Anchors>
  )
}

export default Component
